import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isPlainObject } from "./checks";
import { reduce } from "./objects";
// import { replaceQuotes } from './stringFormat';

export var NullComponent = function NullComponent() {
  return null;
};
export var NullContainer = function NullContainer(_ref) {
  var children = _ref.children;
  return children;
};

/**
 * Обертка для хука, чтобы он выполнялся только на клиенте, на сервере превращается в тыкву
 */
export var clientOnlyHook = function clientOnlyHook(hook) {
  if (typeof window === 'undefined') return function () {
    return undefined;
  };
  return hook;
};
export var spreadDangerousChildren = function spreadDangerousChildren(children) {
  return {
    children: typeof children !== 'string' ? children : null,
    dangerouslySetInnerHTML: typeof children === 'string' ? {
      __html: children
    } : undefined
  };
};

/**
 * Input: isAvailableFlag
 * Output: availableFlag
 */
var statusToClass = function statusToClass(status) {
  return status.indexOf('is') === 0 ? status.substring(2, 3).toLowerCase() + status.substring(3) : status;
};

/**
 * Remove `is` and convert next letter to lowerCase
 */
export var cxBool = function cxBool(classes) {
  return reduce(classes, function (result, value, key) {
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, statusToClass(key), value));
  }, {});
};
export function proxyHandler(originalHandler, extraHandler) {
  return function () {
    if (typeof originalHandler === 'function') originalHandler.apply(void 0, arguments);
    extraHandler.apply(void 0, arguments);
  };
}

/** TODO: heal too much pain typing */
export var getNodeDisplayName = function getNodeDisplayName(node) {
  if (isPlainObject(node) && node.type !== 'string') {
    return node.type.displayName;
  }
  return null;
};

/** Функция, позволяющая делать key из любых данных */
// TODO: Rewrite to rely on WebCrypto API (with Jest support)
export function generateReactKey(input) {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TODO: temporary ts error
    var _input = isPlainObject(input) ? Object.values(input).join('') : input;

    // Делаем строку из input
    var jsonString = JSON.stringify(_input);

    // Делаем base64 строку из получившейся строки
    var encodedString = btoa(encodeURIComponent(jsonString));
    var foldedString = _toConsumableArray(encodedString).reduce(function (acc, char, idx, arr) {
      if (acc.length < 10) {
        // Если четный, оставляем значение как есть
        if (idx % 2 === 0) {
          return "".concat(acc).concat(char);
        }

        // Если нечетный, то берем значение с конца
        var oddChar = arr[arr.length - 1 - Math.floor(idx / 2)];
        return "".concat(acc).concat(oddChar);
      }
      return acc;
    }, '');
    return foldedString.substring(0, 10);
  } catch (e) {
    console.error(e);
    return '';
  }
}